import React, { useContext, useEffect, useState } from "react";
import Layout from "../Layout";
import { LoadContext } from "../App";
import { Helmet } from "react-helmet";
import ToLeft from "../components/Icons/ToLeft";
import ToRight from "../components/Icons/ToRight";
import Cross from "../components/Icons/Cross";

const Realisations = () => {
  const { load } = useContext(LoadContext);
  const sections = [
    ["Traverse", 3, "Conception et réalisation - Projet de la Traverse"],
    ["Vers-Luisant", 42, "Conception et réalisation - Projet Lac Tondohar"],
    ["Tally", 11, "Finition intérieur - Tally-ho"],
    ["Morin-Height", 4, "Extension - Morin height"],
    ["Lac", 6, "Finition extérieur - Lac Ashton"],
    ["Source", 5, "Montée de la source"],
  ];
  const [mainPhoto, setMainPhoto] = useState([0, 2]);
  const [defilement, setDefilement] = useState(false);
  const [scrollTop, setScrollTop] = useState(false);
  const [showProjet, setShowProjet] = useState(true);
  const handlePhoto = (value) => {
    setMainPhoto((prev) => {
      if (value === 1) {
        if (prev[1] === sections[prev[0]][1]) {
          if (prev[0] === sections.length - 1) {
            return [2, 1];
          }
          if (prev[0] === 1) {
            return [0, 1];
          }
          return [prev[0] + 1, 1];
        }
        return [prev[0], prev[1] + 1];
      } else {
        if (prev[1] === 1) {
          if (prev[0] === 0) {
            return [1, sections[1][1]];
          }
          if (prev[0] === 2) {
            return [sections.length - 1, sections[sections.length - 1][1]];
          }
          return [prev[0] - 1, sections[prev[0] - 1][1]];
        }
        return [prev[0], prev[1] - 1];
      }
    });
  };
  const handleScroll = () => {
    if (window.scrollY > 500) {
      setScrollTop(true);
    } else {
      setScrollTop(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [copy, setCopy] = useState("");
  const mail = "vialleconstruction@gmail.com";
  const tel = "438-990-8198";
  const handleCopy = (texte) => {
    setCopy(texte);
    navigator.clipboard.writeText(texte);
    setTimeout(() => {
      setCopy("");
    }, 2000);
  };

  console.log("Page Realisations");
  console.log(load);

  return (
    <>
      <Helmet>
        <title>Realisations | Vialle Construction</title>
        <meta
          name="description"
          content="Vialle Construction vous propose des réalisations de construction et de rénovation, incluant la conception, les finitions intérieures et extérieures, et les extensions"
        />
        <link
          rel="canonical"
          href="https://vialleconstruction.ca/Realisations"
        />
        <meta
          property="og:title"
          content="Realisations | Vialle Construction"
        />
        <meta
          property="og:description"
          content="Vialle Construction vous propose des réalisations de construction et de rénovation, incluant la conception, les finitions intérieures et extérieures, et les extensions"
        />
        <meta
          property="og:url"
          content="https://vialleconstruction.ca/Realisations"
        />
        <meta
          property="og:image"
          content="https://vialleconstruction.ca/assets/logo.png"
        />
      </Helmet>
      <Layout>
        <div className="realisationsPage">
          <button
            className="scrollToTop"
            style={
              scrollTop
                ? { transform: "translateX(calc(0% + -30px))" }
                : { transform: "translateX(100%)" }
            }
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <Cross />
            Retour au choix
          </button>
          <div
            className="containerDefilement"
            style={
              defilement
                ? { transform: "translate(-50%, 0%)" }
                : { transform: "translate(-50%, -100%)" }
            }
          >
            <button
              className="close"
              onClick={() => setDefilement(false)}
            ></button>
            <button className="fleche gauche" onClick={() => handlePhoto(-1)}>
              <ToLeft />
            </button>
            <img
              src={`./assets/IMG/${sections[mainPhoto[0]][0]}/1%20(${
                mainPhoto[1]
              }).webp`}
              alt="Photo d'une construction"
            />
            <button className="fleche droite" onClick={() => handlePhoto(1)}>
              <ToRight />
            </button>
          </div>
          <main>
            <h1>Réalisations</h1>
            <div
              className="realisationsContainer"
              style={load ? { display: "flex" } : { display: "none" }}
            >
              <div className="header-realisations">
                <input type="radio" id="projet" name="section" defaultChecked />
                <label htmlFor="projet" onClick={() => setShowProjet(true)}>
                  PROJET DE A à Z
                </label>
                <input type="radio" id="realisations" name="section" />
                <label
                  htmlFor="realisations"
                  onClick={() => setShowProjet(false)}
                >
                  RÉALISATIONS
                </label>
              </div>
              <div className="contact-realisations">
                <h3>Contactez-nous</h3>
                <div className="contact">
                  <a href="mailto:vialleconstruction@gmail.com">{mail}</a>
                  <button
                    onClick={() => handleCopy(mail)}
                    style={
                      copy === mail
                        ? { background: "#07d707", color: "white" }
                        : { background: "black" }
                    }
                  >
                    {copy === mail ? "Copié !" : "Copier"}
                  </button>
                </div>
                <div className="contact">
                  <a href="tel:+14389908198">{tel}</a>
                  <button
                    onClick={() => handleCopy(tel)}
                    style={
                      copy === tel
                        ? { background: "#07d707", color: "white" }
                        : { background: "black" }
                    }
                  >
                    {copy === tel ? "Copié !" : "Copier"}
                  </button>
                </div>
              </div>
              <div className="sommaire">
                <h3>
                  Voir les {showProjet ? "projets de A à Z" : "réalisations"}{" "}
                </h3>
                <div className="container">
                  <a
                    href="#Traverse"
                    style={
                      showProjet ? { display: "flex" } : { display: "none" }
                    }
                  >
                    Conception et réalisation - Projet de la Traverse
                    <button>Voir</button>
                  </a>
                  <a
                    href="#Vers-Luisant"
                    style={
                      showProjet ? { display: "flex" } : { display: "none" }
                    }
                  >
                    Conception et réalisation - Projet Lac Tondohar
                    <button>Voir</button>
                  </a>
                  <a
                    href="#Tally"
                    style={
                      !showProjet ? { display: "flex" } : { display: "none" }
                    }
                  >
                    Finition intérieur - Tally-ho<button>Voir</button>
                  </a>
                  <a
                    href="#Morin-Height"
                    style={
                      !showProjet ? { display: "flex" } : { display: "none" }
                    }
                  >
                    Extension - Morin height<button>Voir</button>
                  </a>
                  <a
                    href="#Lac"
                    style={
                      !showProjet ? { display: "flex" } : { display: "none" }
                    }
                  >
                    Finition extérieur - Lac Ashton<button>Voir</button>
                  </a>
                  <a
                    href="#Source"
                    style={
                      !showProjet ? { display: "flex" } : { display: "none" }
                    }
                  >
                    Montée de la source<button>Voir</button>
                  </a>
                </div>
              </div>
              <div className="containerGalerie">
                {sections.map((section, index) => {
                  const tabImg = [];
                  for (let i = 1; i <= section[1]; i++) {
                    const src = `./assets/IMG/${section[0]}/1%20(${i}).webp`;
                    tabImg.push(
                      <div
                        key={`${section[0]}-${i}`}
                        onClick={() => {
                          setMainPhoto([index, i]);
                          setDefilement(true);
                        }}
                        className="container-photo"
                      >
                        <span>Voir</span>
                        <div
                          className="photo"
                          style={
                            load ? { display: "flex" } : { display: "none" }
                          }
                        >
                          <img
                            src={src}
                            width={350}
                            alt="Photo d'une construction"
                          ></img>
                        </div>
                      </div>
                    );
                  }

                  return (
                    <div
                      key={index}
                      className="section"
                      style={
                        (showProjet && (index === 0 || index === 1)) ||
                        (!showProjet && index > 1)
                          ? { display: "flex" }
                          : { display: "none" }
                      }
                    >
                      <div className="scroll" id={section[0]}></div>
                      <h3>{section[2]}</h3>
                      <div className="photos">
                        {index === 0 ? (
                          <video controls>
                            <source
                              src="./assets/Traverse.mp4"
                              type="video/mp4"
                            />
                            <track
                              src="captions_en.vtt"
                              kind="captions"
                              srclang="en"
                              label="english_captions"
                            ></track>
                          </video>
                        ) : (
                          ""
                        )}
                        {tabImg}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </main>
        </div>
      </Layout>
    </>
  );
};

export default Realisations;
